export default {
  patientList: "Beteglista",
};
